module.exports = __webpack_public_path__ + "img/二维码.a7347811.png";